import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";

const languages = [
  {
    code: "en",
    name: "English",
    flag: "https://flagcdn.com/us.svg",
    alt: "",
    ariaHidden: true,
  },
  {
    code: "hi",
    name: "Hindi",
    flag: "https://flagcdn.com/in.svg",
    alt: "",
    ariaHidden: true,
  },
  {
    code: "gu",
    name: "Gujarati",
    flag: "https://flagcdn.com/in.svg",
    alt: "",
    ariaHidden: true,
  },
  {
    code: "kn",
    name: "Kannada",
    flag: "https://flagcdn.com/in.svg",
    alt: "",
    ariaHidden: true,
  },
  {
    code: "pa",
    name: "Punjabi",
    flag: "https://flagcdn.com/in.svg",
    alt: "",
    ariaHidden: true,
  },
  {
    code: "te",
    name: "Telugu",
    flag: "https://flagcdn.com/in.svg",
    alt: "",
    ariaHidden: true,
  },
];


const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  const currentLang = languages.find((l) => l.code === i18n.language);

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {/* Button */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 bg-white shadow-md rounded-full px-4 py-2 cursor-pointer hover:shadow-lg transition-all duration-200 transform hover:scale-105"
      >
        <img src={currentLang.flag} alt={currentLang.name} className="w-6 h-6 rounded-full" />
        <span className="font-medium text-gray-800">{currentLang.name}</span>
        <svg
          className={`w-4 h-4 ml-auto transition-transform duration-200 ${open ? "rotate-180" : ""
            }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Dropdown (animated upward) */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            className="absolute bottom-full right-0 w-44 bg-white rounded-xl shadow-lg mt-2 overflow-hidden"
          >
            {languages.map((lang) => (
              <div
                key={lang.code}
                onClick={() => changeLanguage(lang.code)}
                className="flex items-center gap-3 px-4 py-2 cursor-pointer hover:bg-gray-100 transition-colors"
              >
                <img src={lang.flag} alt={lang.name} className="w-5 h-5 rounded-full" />
                <span className="text-gray-700 font-medium">{lang.name}</span>
              </div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LanguageSelector;
